import React from 'react'
import bankMuscat from '../assets/bankMuscat.png'
import SIPC from '../assets/SIPC.png'
import gameIcon from '../assets/gameIcon.PNG'
import udemyCourse from '../assets/udemyCourse.png'

const Work = () => {
  return (
    <div name='work'className='w-full md:h-screen text-gray-300 bg-[#230552] pt-16 pt-[200px]'>
        <div className='max-w-[1000px] mx-auto p-4 flex flex-col justify-center w-full h-full '>
            <div className='pd-8'>
                <p className='text-4xl font-bold inline border-b-4 border-blue-600'>Work</p>
                <p className='py-6'>Check out some of my recent work</p>
            </div>
            {/*Container*/}
            <div className='grid sm:grid-cols-2 md:grid-cols-3 gap-4'>
                
                {/*First item*/}
                <div style={{backgroundImage:`url(${bankMuscat})`}} className='shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div'>
                   {/*Hover effects*/}
                    <div className='opacity-0 group-hover:opacity-100 p-4'>
                         <span className='text-2xl font-bold text-white tracking-wider'>'FMS Officer' in Fraud Monitoring System and Payment Systems Department at Bank Muscat
                         </span>
                    </div>
                </div>

                {/*Second item*/}
                <div style={{backgroundImage:`url(${SIPC})`}} className='shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div'>
                  {/*Hover effects*/}
                   <div className='opacity-0 group-hover:opacity-100 p-4'>
                        <span className='text-2xl font-bold text-white tracking-wider'>'HRIS Specialist' in People and Change Management Department at Sohar Port and Freezone
                        </span>
                   </div>
               </div>
               
               {/*Third item*/}
               <div style={{backgroundImage:`url(${gameIcon})`}} className='shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div'>
                  {/*Hover effects*/}
                   <div className='opacity-0 group-hover:opacity-100 p-4'>
                        <span className='text-2xl font-bold text-white tracking-wider'>Visit My Endless Runner Game Landing Page for Android at Google Store
                        </span>
                        <div className='pt-8 text-center'>
                            <a href='https://play.google.com/store/apps/details?id=com.dardoman94.MetroWayRunner'>
                                 <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg'>
                                 Visit Page
                                 </button>
                             </a>
                        </div>

                   </div>
               </div>

               {/*Fourth item*/}
               <div style={{backgroundImage:`url(${udemyCourse})`}} className='shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div'>
                  {/*Hover effects*/}
                   <div className='opacity-0 group-hover:opacity-100 p-4'>
                        <span className='text-2xl font-bold text-white tracking-wider'>Visit My Udemy Course of how to create an android Game in Unity3D
                        </span>
                        <div className='pt-8 text-center'>
                            <a href='https://www.udemy.com/course/unity-game-development-endless-running-game/'>
                                 <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg'>
                                 Visit Page
                                 </button>
                             </a>
                        </div>
                   </div>
               </div>

            </div>
        </div>
    </div>
  )
}

export default Work